import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { MobileMenu } from './MobileMenu';

export const Topbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <header className="topbar">
        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(true)}
          aria-label="Open menu"
        >
          ☰
        </button>
        <div className="topbar-title">Hash Software</div>

        <div className="topbar-actions">
          <div className="topbar-buttons">
            <button
              className="btn btn-secondary"
              style={{ width: 'auto', padding: '10px 18px', marginTop: 0 }}
              onClick={() => navigate('/months', { state: { openQuick: 'expense' } })}
            >
              + Add expense
            </button>
            <button
              className="btn"
              style={{ width: 'auto', padding: '10px 18px' }}
              onClick={() => navigate('/months', { state: { openQuick: 'credit' } })}
            >
              + Add credit
            </button>
          </div>
          <div className="topbar-user">
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #0b4d99, #1fa2ff)',
                display: 'grid',
                placeItems: 'center',
                color: '#fff',
                fontWeight: 600,
                flexShrink: 0,
              }}
            >
              {user?.initials ?? 'GU'}
            </div>
            <div className="topbar-user-info">
              <div style={{ fontWeight: 600 }}>{user?.name ?? 'Gaurav & Sourabh'}</div>
              <div className="subtle-text" style={{ fontSize: '0.82rem' }}>
                {user?.email}
              </div>
            </div>
            <button
              className="btn btn-secondary"
              style={{ width: 'auto', borderRadius: 999, marginTop: 0, padding: '8px 14px' }}
              onClick={logout}
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
    </>
  );
};

